<kendo-dialog title="{{this.title()}}" width="200px" (close)="this.close()">
    <kendo-label text="{{this.title()}}">
        <kendo-numerictextbox format="n0" [step]="1" [min]="0" [max]="16" [(value)]="value"></kendo-numerictextbox>
    </kendo-label>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.close()">Close</button>
        <button kendoButton (click)="this.doSave()" [themeColor]="'primary'">Save</button>
    </kendo-dialog-actions>
</kendo-dialog>